import { IStateSession, TConfiguration } from './store';
import { TPage } from './pages';

export interface IJsonScenario {
    scenarioId: string;
    pages: TPage[];
    configuration?: TConfiguration;
}

export interface IJson {
    session: IStateSession;
    scenario: IJsonScenario;
}
